/**
 * Swaps the shipping note copy while a subscription protection plan is the selected upsell, and
 * swaps back on the standard plan.
 *
 * A plan counts as a subscription when its card carries a selling plan id, so adding or reordering
 * add-on cards needs no change here. Only loaded when the note has alternate copy.
 */
(() => {
  const getNote = () => document.querySelector('[data-td-shipping-note]');

  const isSubscriptionSelected = () => {
    const card = document
      .querySelector('[data-td-product-upsell]')
      ?.querySelector('[data-upsell-card][aria-checked="true"]');

    return Boolean(card?.dataset.sellingPlanId);
  };

  const sync = () => {
    const note = getNote();
    if (!note) return;

    const defaultText = note.querySelector('[data-shipping-note-default]');
    const subscriptionText = note.querySelector('[data-shipping-note-subscription]');
    if (!defaultText || !subscriptionText) return;

    const showsSubscription = isSubscriptionSelected();

    defaultText.hidden = showsSubscription;
    subscriptionText.hidden = !showsSubscription;
  };

  document.addEventListener('td:upsell-change', sync);

  // Variant changes and section reloads re-render the blocks from Liquid, resetting the note.
  document.addEventListener('product:rerender', () => requestAnimationFrame(sync), true);
  document.addEventListener('shopify:section:load', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
